import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { IconProp } from 'models/Icon';

import './LeadCardTag.styles.scss';

type LeadCardTagProps = {
  className?: string;
  label: string | ReactNode;
  alert?: boolean;
  danger?: boolean;
  success?: boolean;
  info?: boolean;
  Icon?: IconProp;
};

const LeadCardTag: React.FC<LeadCardTagProps> = (props) => {
  const { className, label, alert, danger, success, info, Icon } = props;

  const classes = classNames(
    'lead-card-tag',
    { alert, success, info, danger },
    className,
  );

  const { t } = useTranslation();

  return (
    <p className={classes}>
      {typeof label === 'string' ? t(label) : label}
      {Icon && <Icon />}
    </p>
  );
};

export default LeadCardTag;
